// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// Pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import DepositPage from "./pages/DepositPage";
import PaymentPage from "./pages/PaymentPage";
import WithdrawPage from "./pages/WithdrawPage";
import Packages from "./pages/Packages";
import MyTask from "./pages/MyTask";
import ReferralPage from "./pages/ReferralPage";
import TransactionsPage from "./pages/TransactionsPage";
import AdsDetail from "./pages/AdsDetail";
import Suspended from "./pages/Suspended";

// Admin Pages
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import UserManagement from "./pages/Admin/UserManagment";
import Deposit from "./pages/Admin/Deposit";
import Withdraw from "./pages/Admin/Withdraw";
import TotalDeposit from "./pages/Admin/TotalDeposit";
import UserInfo from "./pages/Admin/UserInfo";
import TotalWithdraw from "./pages/Admin/TotalWithdraw";
import Package from "./pages/Admin/Package";
import TodayWork from "./pages/Admin/TodayWork";
import PaymentSetup from "./pages/Admin/PaymentSetup";
import DepositCancelled from "./pages/Admin/DepositCancelled";
import WithdrawCancelled from "./pages/Admin/WithdrawCancelled";
import AccountSetup from "./pages/Admin/AccountSetup";
import ReferralList from "./pages/Admin/ReferralList";
import PasswordReset from "./pages/Admin/PasswordReset";

// Context + Route Guards
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import ProtectedLayout from "./components/ProtectedLayout";

// Admin Route Guards
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import AdminPublicRoute from "./components/AdminPublicRoute";
import AdminProtectedLayout from "./components/AdminProtectedLayout";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Default route "/" */}
          <Route
            path="/"
            element={
              <PublicRoute>
                <Navigate to="/login" replace />
              </PublicRoute>
            }
          />

          {/* Public Routes */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/register"
            element={
              <PublicRoute>
                <Register />
              </PublicRoute>
            }
          />

          {/* Protected User Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/deposit"
            element={
              <ProtectedRoute>
                <DepositPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment"
            element={
              <ProtectedRoute>
                <PaymentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/withdraw"
            element={
              <ProtectedRoute>
                <WithdrawPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/packages"
            element={
              <ProtectedRoute>
                <Packages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mytask"
            element={
              <ProtectedRoute>
                <MyTask />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-task/:adId"
            element={
              <ProtectedRoute>
                <AdsDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/referral"
            element={
              <ProtectedRoute>
                <ReferralPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transactions"
            element={
              <ProtectedRoute>
                <TransactionsPage />
              </ProtectedRoute>
            }
          />
          <Route path="/suspended" element={<Suspended />} />

          {/* ================= ADMIN ROUTES ================= */}

{/* Admin root */}
<Route path="/admin" element={<Navigate to="/admin/login" replace />} />

{/* Admin Login (Public) */}
<Route
  path="/admin/login"
  element={
    <AdminPublicRoute>
      <AdminLogin />
    </AdminPublicRoute>
  }
/>

{/* Admin Protected Area */}
<Route
  path="/admin"
  element={
    <AdminProtectedRoute>
      <AdminProtectedLayout />
    </AdminProtectedRoute>
  }
>
  <Route path="dashboard" element={<AdminDashboard />} />
  <Route path="users" element={<UserManagement />} />
  <Route path="deposit" element={<Deposit />} />
  <Route path="withdraw" element={<Withdraw />} />
  <Route path="total-deposit" element={<TotalDeposit />} />
  <Route path="total-withdraw" element={<TotalWithdraw />} />
  <Route path="user-info" element={<UserInfo />} />
  <Route path="package" element={<Package />} />
  <Route path="today-work" element={<TodayWork />} />
  <Route path="Payment-Setup" element={<PaymentSetup />} />
  <Route path="Deposit-Cancelled" element={<DepositCancelled />} />
  <Route path="Withdraw-Cancelled" element={<WithdrawCancelled />} />
  <Route path="account-setup" element={<AccountSetup />} />
  <Route path="referrals/:referCode" element={<ReferralList />} />
  <Route path="/admin/password-reset" element={<PasswordReset />} />
</Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;